import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import FeatureFlags from '../../../util/featureFlags';

// Components
import Loader from '../../common/ui/Loader';
import Onboarding from './Onboarding/Onboarding';
import Header from './Header/Header';
import ListView from './ListView/ListView';
import ChartView from './ChartView/ChartView';
import MobileView from './MobileView/MobileView';

// Styles
import './SeatingChart.styles.less';

const SeatingChart = ({
  bannerText,
  bannerType,
  busy,
  selectedGuests,
  tableUUIDs,
  onboarding,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 996 });
  const shortNav = useMediaQuery({ maxWidth: 1200 });

  // useState
  const [view, setView] = useState('LIST');
  // const [isMobile, setIsMobile] = useState(false);
  // const [shortenCopy, setShortenCopy] = useState(false);

  // conditional states:
  if (busy) return <div className="sc__loader"><Loader /></div>;
  if (isMobile) return <MobileView />;
  if (onboarding) return <Onboarding />;

  return (
    <div className="sc">
      <Header shortenCopy={shortNav} />
      {view === 'LIST' && (
        <ListView
          tableCount={tableUUIDs.length}
          numSelectedGuests={selectedGuests.couple.length + selectedGuests.guests.length}
          setView={setView}
          banner={{ bannerText, bannerType }}
        />
      )}
      {FeatureFlags.get('seatingChartView2') && view === 'CHART' && (
        <ChartView
          peopleCount={selectedGuests.couple.length + selectedGuests.guests.length}
          setView={setView}
          tableCount={tableUUIDs.length}
          view={view}
        />
      )}
    </div>
  );
};


SeatingChart.propTypes = {
  busy: PropTypes.bool,
  tableUUIDs: PropTypes.arrayOf(PropTypes.string),
  selectedGuests: PropTypes.shape({
    guests: PropTypes.array,
    couple: PropTypes.array,
  }),
  onboarding: PropTypes.bool,
};

const mapStateToProps = state => ({
  busy: state.seatingChart.busy,
  tableUUIDs: state.seatingChart.orderedTableUUIDs,
  couple: state.guestRail.couple,
  selectedGuests: state.seatingChart.selectedGuests,
  onboarding: state.seatingChart.onboarding,
  bannerType: state.seatingChart.bannerType,
  bannerText: state.seatingChart.bannerText,
});

export default connect(mapStateToProps)(SeatingChart);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/SeatingChart.jsx